module.exports = __webpack_public_path__ + "static/media/intro-1.c2b23dc2.jpg";